// https://www.iban.com/country-codes
export namespace CountryCode {
  export class Enum {
    static readonly AF = new Enum(4, 'AF', 'AFG', 'Afghanistan', 'Afeganistão')
    static readonly AL = new Enum(8, 'AL', 'ALB', 'Albania', 'Albânia')
    static readonly DZ = new Enum(12, 'DZ', 'DZA', 'Algeria', 'Argélia')
    static readonly AS = new Enum(16, 'AS', 'ASM', 'American Samoa', 'Samoa Americana')
    static readonly AD = new Enum(20, 'AD', 'AND', 'Andorra', 'Andorra')
    static readonly AO = new Enum(24, 'AO', 'AGO', 'Angola', 'Angola')
    static readonly AI = new Enum(660, 'AI', 'AIA', 'Anguilla', 'Anguilla')
    static readonly AQ = new Enum(10, 'AQ', 'ATA', 'Antarctica', 'Antártida')
    static readonly AG = new Enum(28, 'AG', 'ATG', 'Antigua and Barbuda', 'Antígua e Barbuda')
    static readonly AR = new Enum(32, 'AR', 'ARG', 'Argentina', 'Argentina')
    static readonly AM = new Enum(51, 'AM', 'ARM', 'Armenia', 'Armênia')
    static readonly AW = new Enum(533, 'AW', 'ABW', 'Aruba', 'Aruba')
    static readonly AU = new Enum(36, 'AU', 'AUS', 'Australia', 'Austrália')
    static readonly AT = new Enum(40, 'AT', 'AUT', 'Austria', 'Áustria')
    static readonly AZ = new Enum(31, 'AZ', 'AZE', 'Azerbaijan', 'Azerbaijão')
    static readonly BS = new Enum(44, 'BS', 'BHS', 'Bahamas', 'Bahamas')
    static readonly BH = new Enum(48, 'BH', 'BHR', 'Bahrain', 'Bahrein')
    static readonly BD = new Enum(50, 'BD', 'BGD', 'Bangladesh', 'Bangladesh')
    static readonly BB = new Enum(52, 'BB', 'BRB', 'Barbados', 'Barbados')
    static readonly BY = new Enum(112, 'BY', 'BLR', 'Belarus', 'Belarus')
    static readonly BE = new Enum(56, 'BE', 'BEL', 'Belgium', 'Bélgica')
    static readonly BZ = new Enum(84, 'BZ', 'BLZ', 'Belize', 'Belize')
    static readonly BJ = new Enum(204, 'BJ', 'BEN', 'Benin', 'Benin')
    static readonly BM = new Enum(60, 'BM', 'BMU', 'Bermuda', 'Bermuda')
    static readonly BT = new Enum(64, 'BT', 'BTN', 'Bhutan', 'Butão')
    static readonly BO = new Enum(
      68,
      'BO',
      'BOL',
      'Bolivia (Plurinational State of)',
      'Bolívia (Estado Plurinacional da)'
    )
    static readonly BQ = new Enum(
      535,
      'BQ',
      'BES',
      'Bonaire, Sint Eustatius and Saba',
      'Bonaire, Santo Eustáquio e Saba'
    )
    static readonly BA = new Enum(70, 'BA', 'BIH', 'Bosnia and Herzegovina', 'Bósnia e Herzegovina')
    static readonly BW = new Enum(72, 'BW', 'BWA', 'Botswana', 'Botsuana')
    static readonly BV = new Enum(74, 'BV', 'BVT', 'Bouvet Island', 'Ilha Bouvet')
    static readonly BR = new Enum(76, 'BR', 'BRA', 'Brazil', 'Brasil')
    static readonly IO = new Enum(
      86,
      'IO',
      'IOT',
      'British Indian Ocean Territory',
      'Território Britânico do Oceano Índico'
    )
    static readonly BN = new Enum(96, 'BN', 'BRN', 'Brunei Darussalam', 'Brunei Darussalam')
    static readonly BG = new Enum(100, 'BG', 'BGR', 'Bulgaria', 'Bulgária')
    static readonly BF = new Enum(854, 'BF', 'BFA', 'Burkina Faso', 'Burkina Faso')
    static readonly BI = new Enum(108, 'BI', 'BDI', 'Burundi', 'Burundi')
    static readonly CV = new Enum(132, 'CV', 'CPV', 'Cabo Verde', 'Cabo Verde')
    static readonly KH = new Enum(116, 'KH', 'KHM', 'Cambodia', 'Camboja')
    static readonly CM = new Enum(120, 'CM', 'CMR', 'Cameroon', 'Camarões')
    static readonly CA = new Enum(124, 'CA', 'CAN', 'Canada', 'Canadá')
    static readonly KY = new Enum(136, 'KY', 'CYM', 'Cayman Islands', 'Ilhas Cayman')
    static readonly CF = new Enum(
      140,
      'CF',
      'CAF',
      'Central African Republic',
      'República Centro-Africana'
    )
    static readonly TD = new Enum(148, 'TD', 'TCD', 'Chad', 'Chade')
    static readonly CL = new Enum(152, 'CL', 'CHL', 'Chile', 'Chile')
    static readonly CN = new Enum(156, 'CN', 'CHN', 'China', 'China')
    static readonly CX = new Enum(162, 'CX', 'CXR', 'Christmas Island', 'Ilha Christmas')
    static readonly CC = new Enum(
      166,
      'CC',
      'CCK',
      'Cocos (Keeling) Islands',
      'Ilhas Cocos (Keeling)'
    )
    static readonly CO = new Enum(170, 'CO', 'COL', 'Colombia', 'Colômbia')
    static readonly KM = new Enum(174, 'KM', 'COM', 'Comoros', 'Comores')
    static readonly CG = new Enum(178, 'CG', 'COG', 'Congo', 'Congo')
    static readonly CD = new Enum(
      180,
      'CD',
      'COD',
      'Congo, Democratic Republic of the',
      'Congo, República Democrática do'
    )
    static readonly CK = new Enum(184, 'CK', 'COK', 'Cook Islands', 'Ilhas Cook')
    static readonly CR = new Enum(188, 'CR', 'CRI', 'Costa Rica', 'Costa Rica')
    static readonly CI = new Enum(384, 'CI', 'CIV', "Côte d'Ivoire", 'Costa do Marfim')
    static readonly HR = new Enum(191, 'HR', 'HRV', 'Croatia', 'Croácia')
    static readonly CU = new Enum(192, 'CU', 'CUB', 'Cuba', 'Cuba')
    static readonly CW = new Enum(531, 'CW', 'CUW', 'Curaçao', 'Curaçao')
    static readonly CY = new Enum(196, 'CY', 'CYP', 'Cyprus', 'Chipre')
    static readonly CZ = new Enum(203, 'CZ', 'CZE', 'Czechia', 'Tchéquia')
    static readonly DK = new Enum(208, 'DK', 'DNK', 'Denmark', 'Dinamarca')
    static readonly DJ = new Enum(262, 'DJ', 'DJI', 'Djibouti', 'Djibuti')
    static readonly DM = new Enum(212, 'DM', 'DMA', 'Dominica', 'Dominica')
    static readonly DO = new Enum(214, 'DO', 'DOM', 'Dominican Republic', 'República Dominicana')
    static readonly EC = new Enum(218, 'EC', 'ECU', 'Ecuador', 'Equador')
    static readonly EG = new Enum(818, 'EG', 'EGY', 'Egypt', 'Egito')
    static readonly SV = new Enum(222, 'SV', 'SLV', 'El Salvador', 'El Salvador')
    static readonly GQ = new Enum(226, 'GQ', 'GNQ', 'Equatorial Guinea', 'Guiné Equatorial')
    static readonly ER = new Enum(232, 'ER', 'ERI', 'Eritrea', 'Eritreia')
    static readonly EE = new Enum(233, 'EE', 'EST', 'Estonia', 'Estônia')
    static readonly SZ = new Enum(748, 'SZ', 'SWZ', 'Eswatini', 'Eswatini')
    static readonly ET = new Enum(231, 'ET', 'ETH', 'Ethiopia', 'Etiópia')
    static readonly FK = new Enum(238, 'FK', 'FLK', 'Falkland Islands (Malvinas)', 'Ilhas Malvinas')
    static readonly FO = new Enum(234, 'FO', 'FRO', 'Faroe Islands', 'Ilhas Faroé')
    static readonly FJ = new Enum(242, 'FJ', 'FJI', 'Fiji', 'Fiji')
    static readonly FI = new Enum(246, 'FI', 'FIN', 'Finland', 'Finlândia')
    static readonly FR = new Enum(250, 'FR', 'FRA', 'France', 'França')
    static readonly GF = new Enum(254, 'GF', 'GUF', 'French Guiana', 'Guiana Francesa')
    static readonly PF = new Enum(258, 'PF', 'PYF', 'French Polynesia', 'Polinésia Francesa')
    static readonly TF = new Enum(
      260,
      'TF',
      'ATF',
      'French Southern Territories',
      'Territórios Franceses do Sul'
    )
    static readonly GA = new Enum(266, 'GA', 'GAB', 'Gabon', 'Gabão')
    static readonly GM = new Enum(270, 'GM', 'GMB', 'Gambia', 'Gâmbia')
    static readonly GE = new Enum(268, 'GE', 'GEO', 'Georgia', 'Geórgia')
    static readonly DE = new Enum(276, 'DE', 'DEU', 'Germany', 'Alemanha')
    static readonly GH = new Enum(288, 'GH', 'GHA', 'Ghana', 'Gana')
    static readonly GI = new Enum(292, 'GI', 'GIB', 'Gibraltar', 'Gibraltar')
    static readonly GR = new Enum(300, 'GR', 'GRC', 'Greece', 'Grécia')
    static readonly GL = new Enum(304, 'GL', 'GRL', 'Greenland', 'Groenlândia')
    static readonly GD = new Enum(308, 'GD', 'GRD', 'Grenada', 'Granada')
    static readonly GP = new Enum(312, 'GP', 'GLP', 'Guadeloupe', 'Guadalupe')
    static readonly GU = new Enum(316, 'GU', 'GUM', 'Guam', 'Guam')
    static readonly GT = new Enum(320, 'GT', 'GTM', 'Guatemala', 'Guatemala')
    static readonly GG = new Enum(831, 'GG', 'GGY', 'Guernsey', 'Guernsey')
    static readonly GN = new Enum(324, 'GN', 'GIN', 'Guinea', 'Guiné')
    static readonly GW = new Enum(624, 'GW', 'GNB', 'Guinea-Bissau', 'Guiné-Bissau')
    static readonly GY = new Enum(328, 'GY', 'GUY', 'Guyana', 'Guiana')
    static readonly HT = new Enum(332, 'HT', 'HTI', 'Haiti', 'Haiti')
    static readonly HM = new Enum(
      334,
      'HM',
      'HMD',
      'Heard Island and McDonald Islands',
      'Ilha Heard e Ilhas McDonald'
    )
    static readonly VA = new Enum(336, 'VA', 'VAT', 'Holy See', 'Santa Sé')
    static readonly HN = new Enum(340, 'HN', 'HND', 'Honduras', 'Honduras')
    static readonly HK = new Enum(344, 'HK', 'HKG', 'Hong Kong', 'Hong Kong')
    static readonly HU = new Enum(348, 'HU', 'HUN', 'Hungary', 'Hungria')
    static readonly IS = new Enum(352, 'IS', 'ISL', 'Iceland', 'Islândia')
    static readonly IN = new Enum(356, 'IN', 'IND', 'India', 'Índia')
    static readonly ID = new Enum(360, 'ID', 'IDN', 'Indonesia', 'Indonésia')
    static readonly IR = new Enum(
      364,
      'IR',
      'IRN',
      'Iran (Islamic Republic of)',
      'Irã (República Islâmica do)'
    )
    static readonly IQ = new Enum(368, 'IQ', 'IRQ', 'Iraq', 'Iraque')
    static readonly IE = new Enum(372, 'IE', 'IRL', 'Ireland', 'Irlanda')
    static readonly IM = new Enum(833, 'IM', 'IMN', 'Isle of Man', 'Ilha de Man')
    static readonly IL = new Enum(376, 'IL', 'ISR', 'Israel', 'Israel')
    static readonly IT = new Enum(380, 'IT', 'ITA', 'Italy', 'Itália')
    static readonly JM = new Enum(388, 'JM', 'JAM', 'Jamaica', 'Jamaica')
    static readonly JP = new Enum(392, 'JP', 'JPN', 'Japan', 'Japão')
    static readonly JE = new Enum(832, 'JE', 'JEY', 'Jersey', 'Jersey')
    static readonly JO = new Enum(400, 'JO', 'JOR', 'Jordan', 'Jordânia')
    static readonly KZ = new Enum(398, 'KZ', 'KAZ', 'Kazakhstan', 'Cazaquistão')
    static readonly KE = new Enum(404, 'KE', 'KEN', 'Kenya', 'Quênia')
    static readonly KI = new Enum(296, 'KI', 'KIR', 'Kiribati', 'Kiribati')
    static readonly KP = new Enum(
      408,
      'KP',
      'PRK',
      "Korea (Democratic People's Republic of)",
      'Coreia (República Popular Democrática da)'
    )
    static readonly KR = new Enum(410, 'KR', 'KOR', 'Korea, Republic of', 'Coreia, República da')
    static readonly KW = new Enum(414, 'KW', 'KWT', 'Kuwait', 'Kuwait')
    static readonly KG = new Enum(417, 'KG', 'KGZ', 'Kyrgyzstan', 'Quirguistão')
    static readonly LA = new Enum(
      418,
      'LA',
      'LAO',
      "Lao People's Democratic Republic",
      'República Democrática Popular do Laos'
    )
    static readonly LV = new Enum(428, 'LV', 'LVA', 'Latvia', 'Letônia')
    static readonly LB = new Enum(422, 'LB', 'LBN', 'Lebanon', 'Líbano')
    static readonly LS = new Enum(426, 'LS', 'LSO', 'Lesotho', 'Lesoto')
    static readonly LR = new Enum(430, 'LR', 'LBR', 'Liberia', 'Libéria')
    static readonly LY = new Enum(434, 'LY', 'LBY', 'Libya', 'Líbia')
    static readonly LI = new Enum(438, 'LI', 'LIE', 'Liechtenstein', 'Liechtenstein')
    static readonly LT = new Enum(440, 'LT', 'LTU', 'Lithuania', 'Lituânia')
    static readonly LU = new Enum(442, 'LU', 'LUX', 'Luxembourg', 'Luxemburgo')
    static readonly MO = new Enum(446, 'MO', 'MAC', 'Macao', 'Macau')
    static readonly MG = new Enum(450, 'MG', 'MDG', 'Madagascar', 'Madagascar')
    static readonly MW = new Enum(454, 'MW', 'MWI', 'Malawi', 'Malawi')
    static readonly MY = new Enum(458, 'MY', 'MYS', 'Malaysia', 'Malásia')
    static readonly MV = new Enum(462, 'MV', 'MDV', 'Maldives', 'Maldivas')
    static readonly ML = new Enum(466, 'ML', 'MLI', 'Mali', 'Mali')
    static readonly MT = new Enum(470, 'MT', 'MLT', 'Malta', 'Malta')
    static readonly MH = new Enum(584, 'MH', 'MHL', 'Marshall Islands', 'Ilhas Marshall')
    static readonly MQ = new Enum(474, 'MQ', 'MTQ', 'Martinique', 'Martinica')
    static readonly MR = new Enum(478, 'MR', 'MRT', 'Mauritania', 'Mauritânia')
    static readonly MU = new Enum(480, 'MU', 'MUS', 'Mauritius', 'Maurício')
    static readonly YT = new Enum(175, 'YT', 'MYT', 'Mayotte', 'Mayotte')
    static readonly MX = new Enum(484, 'MX', 'MEX', 'Mexico', 'México')
    static readonly FM = new Enum(
      583,
      'FM',
      'FSM',
      'Micronesia (Federated States of)',
      'Micronésia (Estados Federados da)'
    )
    static readonly MD = new Enum(
      498,
      'MD',
      'MDA',
      'Moldova, Republic of',
      'Moldávia, República da'
    )
    static readonly MC = new Enum(492, 'MC', 'MCO', 'Monaco', 'Mônaco')
    static readonly MN = new Enum(496, 'MN', 'MNG', 'Mongolia', 'Mongólia')
    static readonly ME = new Enum(499, 'ME', 'MNE', 'Montenegro', 'Montenegro')
    static readonly MS = new Enum(500, 'MS', 'MSR', 'Montserrat', 'Montserrat')
    static readonly MA = new Enum(504, 'MA', 'MAR', 'Morocco', 'Marrocos')
    static readonly MZ = new Enum(508, 'MZ', 'MOZ', 'Mozambique', 'Moçambique')
    static readonly MM = new Enum(104, 'MM', 'MMR', 'Myanmar', 'Myanmar')
    static readonly NA = new Enum(516, 'NA', 'NAM', 'Namibia', 'Namíbia')
    static readonly NR = new Enum(520, 'NR', 'NRU', 'Nauru', 'Nauru')
    static readonly NP = new Enum(524, 'NP', 'NPL', 'Nepal', 'Nepal')
    static readonly NL = new Enum(528, 'NL', 'NLD', 'Netherlands', 'Países Baixos')
    static readonly NC = new Enum(540, 'NC', 'NCL', 'New Caledonia', 'Nova Caledônia')
    static readonly NZ = new Enum(554, 'NZ', 'NZL', 'New Zealand', 'Nova Zelândia')
    static readonly NI = new Enum(558, 'NI', 'NIC', 'Nicaragua', 'Nicarágua')
    static readonly NE = new Enum(562, 'NE', 'NER', 'Niger', 'Níger')
    static readonly NG = new Enum(566, 'NG', 'NGA', 'Nigeria', 'Nigéria')
    static readonly NU = new Enum(570, 'NU', 'NIU', 'Niue', 'Niue')
    static readonly NF = new Enum(574, 'NF', 'NFK', 'Norfolk Island', 'Ilha Norfolk')
    static readonly MP = new Enum(
      580,
      'MP',
      'MNP',
      'Northern Mariana Islands',
      'Ilhas Marianas do Norte'
    )
    static readonly NO = new Enum(578, 'NO', 'NOR', 'Norway', 'Noruega')
    static readonly OM = new Enum(512, 'OM', 'OMN', 'Oman', 'Omã')
    static readonly PK = new Enum(586, 'PK', 'PAK', 'Pakistan', 'Paquistão')
    static readonly PW = new Enum(585, 'PW', 'PLW', 'Palau', 'Palau')
    static readonly PS = new Enum(275, 'PS', 'PSE', 'Palestine, State of', 'Palestina, Estado da')
    static readonly PA = new Enum(591, 'PA', 'PAN', 'Panama', 'Panamá')
    static readonly PG = new Enum(598, 'PG', 'PNG', 'Papua New Guinea', 'Papua-Nova Guiné')
    static readonly PY = new Enum(600, 'PY', 'PRY', 'Paraguay', 'Paraguai')
    static readonly PE = new Enum(604, 'PE', 'PER', 'Peru', 'Peru')
    static readonly PH = new Enum(608, 'PH', 'PHL', 'Philippines', 'Filipinas')
    static readonly PN = new Enum(612, 'PN', 'PCN', 'Pitcairn', 'Pitcairn')
    static readonly PL = new Enum(616, 'PL', 'POL', 'Poland', 'Polônia')
    static readonly PT = new Enum(620, 'PT', 'PRT', 'Portugal', 'Portugal')
    static readonly PR = new Enum(630, 'PR', 'PRI', 'Puerto Rico', 'Porto Rico')
    static readonly QA = new Enum(634, 'QA', 'QAT', 'Qatar', 'Catar')
    static readonly MK = new Enum(
      807,
      'MK',
      'MKD',
      'Republic of North Macedonia',
      'República da Macedônia do Norte'
    )
    static readonly RO = new Enum(642, 'RO', 'ROU', 'Romania', 'Romênia')
    static readonly RU = new Enum(643, 'RU', 'RUS', 'Russian Federation', 'Federação Russa')
    static readonly RW = new Enum(646, 'RW', 'RWA', 'Rwanda', 'Ruanda')
    static readonly RE = new Enum(638, 'RE', 'REU', 'Réunion', 'Reunião')
    static readonly BL = new Enum(652, 'BL', 'BLM', 'Saint Barthélemy', 'São Bartolomeu')
    static readonly SH = new Enum(
      654,
      'SH',
      'SHN',
      'Saint Helena, Ascension and Tristan da Cunha',
      'Santa Helena, Ascensão e Tristão da Cunha'
    )
    static readonly KN = new Enum(
      659,
      'KN',
      'KNA',
      'Saint Kitts and Nevis',
      'São Cristóvão e Nevis'
    )
    static readonly LC = new Enum(662, 'LC', 'LCA', 'Saint Lucia', 'Santa Lúcia')
    static readonly MF = new Enum(
      663,
      'MF',
      'MAF',
      'Saint Martin (French part)',
      'São Martinho (parte francesa)'
    )
    static readonly PM = new Enum(
      666,
      'PM',
      'SPM',
      'Saint Pierre and Miquelon',
      'São Pedro e Miquelão'
    )
    static readonly VC = new Enum(
      670,
      'VC',
      'VCT',
      'Saint Vincent and the Grenadines',
      'São Vicente e Granadinas'
    )
    static readonly WS = new Enum(882, 'WS', 'WSM', 'Samoa', 'Samoa')
    static readonly SM = new Enum(674, 'SM', 'SMR', 'San Marino', 'San Marino')
    static readonly ST = new Enum(678, 'ST', 'STP', 'Sao Tome and Principe', 'São Tomé e Príncipe')
    static readonly SA = new Enum(682, 'SA', 'SAU', 'Saudi Arabia', 'Arábia Saudita')
    static readonly SN = new Enum(686, 'SN', 'SEN', 'Senegal', 'Senegal')
    static readonly RS = new Enum(688, 'RS', 'SRB', 'Serbia', 'Sérvia')
    static readonly SC = new Enum(690, 'SC', 'SYC', 'Seychelles', 'Seychelles')
    static readonly SL = new Enum(694, 'SL', 'SLE', 'Sierra Leone', 'Serra Leoa')
    static readonly SG = new Enum(702, 'SG', 'SGP', 'Singapore', 'Singapura')
    static readonly SX = new Enum(
      534,
      'SX',
      'SXM',
      'Sint Maarten (Dutch part)',
      'São Martinho (parte holandesa)'
    )
    static readonly SK = new Enum(703, 'SK', 'SVK', 'Slovakia', 'Eslováquia')
    static readonly SI = new Enum(705, 'SI', 'SVN', 'Slovenia', 'Eslovênia')
    static readonly SB = new Enum(90, 'SB', 'SLB', 'Solomon Islands', 'Ilhas Salomão')
    static readonly SO = new Enum(706, 'SO', 'SOM', 'Somalia', 'Somália')
    static readonly ZA = new Enum(710, 'ZA', 'ZAF', 'South Africa', 'África do Sul')
    static readonly GS = new Enum(
      239,
      'GS',
      'SGS',
      'South Georgia and the South Sandwich Islands',
      'Geórgia do Sul e Ilhas Sandwich do Sul'
    )
    static readonly SS = new Enum(728, 'SS', 'SSD', 'South Sudan', 'Sudão do Sul')
    static readonly ES = new Enum(724, 'ES', 'ESP', 'Spain', 'Espanha')
    static readonly LK = new Enum(144, 'LK', 'LKA', 'Sri Lanka', 'Sri Lanka')
    static readonly SD = new Enum(729, 'SD', 'SDN', 'Sudan', 'Sudão')
    static readonly SR = new Enum(740, 'SR', 'SUR', 'Suriname', 'Suriname')
    static readonly SJ = new Enum(
      744,
      'SJ',
      'SJM',
      'Svalbard and Jan Mayen',
      'Svalbard e Jan Mayen'
    )
    static readonly SE = new Enum(752, 'SE', 'SWE', 'Sweden', 'Suécia')
    static readonly CH = new Enum(756, 'CH', 'CHE', 'Switzerland', 'Suíça')
    static readonly SY = new Enum(760, 'SY', 'SYR', 'Syrian Arab Republic', 'República Árabe Síria')
    static readonly TW = new Enum(
      158,
      'TW',
      'TWN',
      'Taiwan, Province of China',
      'Taiwan, Província da China'
    )
    static readonly TJ = new Enum(762, 'TJ', 'TJK', 'Tajikistan', 'Tajiquistão')
    static readonly TZ = new Enum(
      834,
      'TZ',
      'TZA',
      'Tanzania, United Republic of',
      'Tanzânia, República Unida da'
    )
    static readonly TH = new Enum(764, 'TH', 'THA', 'Thailand', 'Tailândia')
    static readonly TL = new Enum(626, 'TL', 'TLS', 'Timor-Leste', 'Timor-Leste')
    static readonly TG = new Enum(768, 'TG', 'TGO', 'Togo', 'Togo')
    static readonly TK = new Enum(772, 'TK', 'TKL', 'Tokelau', 'Tokelau')
    static readonly TO = new Enum(776, 'TO', 'TON', 'Tonga', 'Tonga')
    static readonly TT = new Enum(780, 'TT', 'TTO', 'Trinidad and Tobago', 'Trinidad e Tobago')
    static readonly TN = new Enum(788, 'TN', 'TUN', 'Tunisia', 'Tunísia')
    static readonly TR = new Enum(792, 'TR', 'TUR', 'Turkey', 'Turquia')
    static readonly TM = new Enum(795, 'TM', 'TKM', 'Turkmenistan', 'Turcomenistão')
    static readonly TC = new Enum(
      796,
      'TC',
      'TCA',
      'Turks and Caicos Islands',
      'Ilhas Turks e Caicos'
    )
    static readonly TV = new Enum(798, 'TV', 'TUV', 'Tuvalu', 'Tuvalu')
    static readonly UG = new Enum(800, 'UG', 'UGA', 'Uganda', 'Uganda')
    static readonly UA = new Enum(804, 'UA', 'UKR', 'Ukraine', 'Ucrânia')
    static readonly AE = new Enum(
      784,
      'AE',
      'ARE',
      'United Arab Emirates',
      'Emirados Árabes Unidos'
    )
    static readonly GB = new Enum(
      826,
      'GB',
      'GBR',
      'United Kingdom of Great Britain and Northern Ireland',
      'Reino Unido da Grã-Bretanha e Irlanda do Norte'
    )
    static readonly UM = new Enum(
      581,
      'UM',
      'UMI',
      'United States Minor Outlying Islands',
      'Ilhas Menores Distantes dos Estados Unidos'
    )
    static readonly US = new Enum(
      840,
      'US',
      'USA',
      'United States of America',
      'Estados Unidos da América'
    )
    static readonly UY = new Enum(858, 'UY', 'URY', 'Uruguay', 'Uruguai')
    static readonly UZ = new Enum(860, 'UZ', 'UZB', 'Uzbekistan', 'Uzbequistão')
    static readonly VU = new Enum(548, 'VU', 'VUT', 'Vanuatu', 'Vanuatu')
    static readonly VE = new Enum(
      862,
      'VE',
      'VEN',
      'Venezuela (Bolivarian Republic of)',
      'Venezuela (República Bolivariana da)'
    )
    static readonly VN = new Enum(704, 'VN', 'VNM', 'Viet Nam', 'Vietnã')
    static readonly VG = new Enum(
      92,
      'VG',
      'VGB',
      'Virgin Islands (British)',
      'Ilhas Virgens (Britânicas)'
    )
    static readonly VI = new Enum(
      850,
      'VI',
      'VIR',
      'Virgin Islands (U.S.)',
      'Ilhas Virgens (Americanas)'
    )
    static readonly WF = new Enum(876, 'WF', 'WLF', 'Wallis and Futuna', 'Wallis e Futuna')
    static readonly EH = new Enum(732, 'EH', 'ESH', 'Western Sahara', 'Saara Ocidental')
    static readonly YE = new Enum(887, 'YE', 'YEM', 'Yemen', 'Iêmen')
    static readonly ZM = new Enum(894, 'ZM', 'ZMB', 'Zambia', 'Zâmbia')
    static readonly ZW = new Enum(716, 'ZW', 'ZWE', 'Zimbabwe', 'Zimbábue')

    private constructor(
      public readonly id: number,
      public readonly name: string,
      public readonly abbreviation: string,
      public readonly title: string,
      public readonly localeTitle: string
    ) {}
  }

  export const getByValue = (value: string | undefined): Enum => {
    if (!value) return CountryCode.Enum.BR
    return (
      Object.values(CountryCode.Enum).find(country => country.name === value) ?? CountryCode.Enum.BR
    )
  }
}
